import {
  IData,
  IResponse,
  ISpecialities,
  ISpecialitiesData,
  IStateList,
  ISubscriptionQuota,
  IProvinceList,
  ICountries,
} from '@/types/interfaces';
// eslint-disable-next-line import/no-cycle
import ApiService from '@/services/ApiService';

export default class GeneralService {
  public static getStates(): Promise<IResponse<IStateList>> {
    return ApiService.getAndReturnData('/common/states');
  }

  public static getProvinces(): Promise<IResponse<IProvinceList>> {
    return ApiService.getAndReturnData('/common/provinces');
  }

  public static getCountries(): Promise<IResponse<IData<ICountries[]>>> {
    return ApiService.getAndReturnData('/countries');
  }

  public static getSpecialities(): Promise<IResponse<ISpecialitiesData>> {
    return ApiService.getAndReturnData('/common/specialities');
  }

  public static selectedSpeciality(): Promise<IResponse<IData<ISpecialities[]>>> {
    return ApiService.getAndReturnData('cmsimporting/taxonomy/list');
  }

  public static getSubscriptionQuota(): Promise<IResponse<IData<ISubscriptionQuota>>> {
    return ApiService.getAndReturnData('subscription/quota');
  }
}
